import React, { useEffect, useState, useMemo } from 'react';
import MatchListSelector from '../../match-list-selector';
import { MatchListCommon, FilteredMarketGroupsOverview } from '../../utils/match-list-models';
import { MatchListItemLayout } from "../../utils/match-list.constants";
import { PlatformTypes } from '@om-fe/utils';
import { MarketGroupOverviewModel } from '@om-fe/models';
import { GetMarketGroupsResponse, GetMarketGroupsOptions } from '@om-fe/api';
import { RpcStateStatus, useRpcState } from '@om-fe/widgets/dist/common/rpc/rpc-state.hooks';
import keyBy from 'lodash/keyBy';

export interface TournamentMatchListPublicProps extends MatchListCommon {
    readonly tournamentId: string;
    readonly locationId?: string;
    readonly eventCategoryId?: string;
    readonly isDefault?: boolean;
    readonly itemLayout?: MatchListItemLayout;
    readonly marketGroupsOverviewNumber?: number;
    readonly hasMarketSelector: boolean;
    readonly deviceType?: PlatformTypes;
    readonly disciplineId: string;
    readonly groupOverview: string;
    readonly setGroupOverview: (item: string) => void;
    readonly setLoading: (item: boolean) => void;
}

type TournamentMatchListSelectorProps = TournamentMatchListPublicProps;

function TournamentMatchListSelector(
    {
        mainMarketsLimit,
        disciplineId,
        liveStatus,
        deviceType,
        groupOverview,
        setGroupOverview,
        setLoading,
    }: TournamentMatchListSelectorProps,
) {
    const [filteredMarketGroupsOverview, setFilteredMarketGroupsOverview] = useState<Record<string, FilteredMarketGroupsOverview>>();
    const [filteredMarketGroupsOverviewList, setFilteredMarketGroupsOverviewList] = useState<string[]>([]);
    const params: GetMarketGroupsOptions = useMemo(() => ({ sportId: disciplineId, liveStatus }), [disciplineId, liveStatus]);
    const [rpcResponse] = useRpcState<GetMarketGroupsResponse>('marketGroupsOverview', params);
    
    useEffect(()=>{
        if (rpcResponse.status === RpcStateStatus.Success) {
            const { data } = rpcResponse;
            const marketGroupsOverviewData: MarketGroupOverviewModel[] | undefined = data.response;
            const filteredMarketGroupsOverviewData: Record<string, FilteredMarketGroupsOverview> = keyBy(marketGroupsOverviewData, 'id');
            const filteredMarketGroupsOverviewListData = marketGroupsOverviewData.map(item => item.id);
            const groupOverviewData = filteredMarketGroupsOverviewListData.slice(0, mainMarketsLimit).join(',');
            setFilteredMarketGroupsOverview(filteredMarketGroupsOverviewData);
            setFilteredMarketGroupsOverviewList(filteredMarketGroupsOverviewListData);
            setGroupOverview(groupOverviewData);
            setLoading(false);
        }
    },[rpcResponse]);

    if (
        rpcResponse.status === RpcStateStatus.Loading || 
        rpcResponse.status === RpcStateStatus.Initial || 
        rpcResponse.status === RpcStateStatus.Failed || 
        typeof groupOverview === 'undefined') {
        return null;
    }

    const selectGroupsOverview = (item: string) => {
        const listSelected = mainMarketsLimit === 1
            ? item
            : filteredMarketGroupsOverviewList?.slice(0, mainMarketsLimit - 1)
                .concat(item)
                .join(',');
            setGroupOverview(listSelected);
    }
    
    return (
        <>
            {!!filteredMarketGroupsOverviewList.length && (
                    <MatchListSelector
                        selectGroupsOverview={selectGroupsOverview}
                        filteredMarketGroupsOverview={filteredMarketGroupsOverview}
                        filteredMarketGroupsOverviewList={filteredMarketGroupsOverviewList}
                        marketSelected={groupOverview}
                        mainMarketsLimit={mainMarketsLimit}
                        isHasDrawer={true}
                        deviceType={deviceType}
                    />
                )
            }
        </>
        
    );
}

export default TournamentMatchListSelector;
